import React, { useCallback, useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';

import { useMediaQuery } from 'react-responsive';

import {
  postMaintenanceDocumentsRequest,
  getDownloadFile,
} from '~/services/technicalDocumentationServices';

import {
  Container,
  IconDownload,
  IconCheck,
  ContentWrap,
  ContentTitle,
  ContentDescription,
  BoxFileOs,
  WrapContentFile,
  FileText,
  FileOsNumber,
  LinesWrap,
  FirstLine,
  SecondLine,
  WrapButtons,
  ButtonDownload,
  ButtonEmail,
  WrapButtonsAndFile,
  ContainerStatusDownload,
  ContentStatusDownload,
  PercentDownloadWrap,
  PercentNumberAndStatusWrap,
  PercentStatusBar,
  TextOS,
  TextOsNumber,
  NumberPercentWrap,
} from './styles';
import ModalContent from '~/modules/Granel/pages/documentacao/ModalContent';
import { useDocumentationOS } from '~/hooks/useDocumentationOS';

function FileItemOs({
  osNumber,
  createdDate,
  installedBaseNickname,
  installedBaseCode,
  osType,
  link,
}) {
  const [siteId, setSiteId] = useState(null);
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mailSuccess, setMailSuccess] = useState(false);
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const isTablet = useMediaQuery({ maxWidth: 740 });
  const isMobile = useMediaQuery({ maxWidth: 620 });

  const { documentsRequest, addNewDocument } = useDocumentationOS();

  useEffect(() => {
    async function getSiteId() {
      const customerSiteId = await localStorage.getItem(
        '@UltragazEmpresarial:customerSiteId'
      );
      setSiteId(customerSiteId);
    }
    if (!siteId) getSiteId();
  }, [siteId]);

  const handleClickCreateOsAndSendMail = useCallback(async () => {
    const contactIdSfResponse = localStorage.getItem(
      '@UltragazEmpresarial:contactIdSf'
    );
    const body = {
      numberOs: osNumber,
      installBaseCode: installedBaseCode,
      contactIdSf: contactIdSfResponse,
    };

    if (email) {
      setIsLoading(true);
      body.email = email;
    } else {
      addNewDocument({ osNumber });
    }
    const responsePostMaintenanceDocuments =
      await postMaintenanceDocumentsRequest(body);
    if (email) {
      if (responsePostMaintenanceDocuments.status === 200) {
        setMailSuccess(true);
      }
    }
    setIsLoading(false);
  }, [osNumber, installedBaseCode, setIsLoading, email, addNewDocument]);

  const handleClickDownloadOs = useCallback(async (linkRequest) => {
    setLoader(true);
    await getDownloadFile(linkRequest);
    setLoader(false);
  }, []);

  const documentRequest = useMemo(() => {
    const indexDocument = documentsRequest.findIndex(
      (document) => document?.osNumber === osNumber
    );
    return documentsRequest[indexDocument];
  }, [documentsRequest, osNumber]);

  return (
    <Container>
      {link && (
        <WrapButtonsAndFile>
          <WrapContentFile>
            <BoxFileOs noMargin isLink>
              <IconCheck />
            </BoxFileOs>
            <LinesWrap>
              <FirstLine>
                <FileText>OS</FileText>
                <FileOsNumber>{` ${osNumber} `}</FileOsNumber>
                <FileText>gerada com sucesso!</FileText>
              </FirstLine>
              <SecondLine>
                <FileText>O arquivo ficará disponível por 7 dias.</FileText>
              </SecondLine>
            </LinesWrap>
          </WrapContentFile>
          <WrapButtons>
            <ButtonDownload
              disabled={loader}
              buttonType={loader ? 'disabled' : 'outline'}
              onClick={() => handleClickDownloadOs(link)}
            >
              {loader ? 'Aguarde...' : 'Baixar arquivo'}
            </ButtonDownload>
            <ButtonEmail onClick={() => setShowModal(true)}>
              Enviar por e-mail
            </ButtonEmail>
          </WrapButtons>
        </WrapButtonsAndFile>
      )}
      {!link && !documentRequest?.downloadItem && (
        <>
          <BoxFileOs noMargin onClick={handleClickCreateOsAndSendMail}>
            <IconDownload />
          </BoxFileOs>
          <ContentWrap isMobile={isMobile}>
            <ContentTitle>Número da OS</ContentTitle>
            <ContentDescription>{osNumber}</ContentDescription>
          </ContentWrap>
          {!isTablet && (
            <ContentWrap>
              <ContentTitle>Data de criação</ContentTitle>
              <ContentDescription>
                {moment(createdDate).format('DD/MM/YYYY')}
              </ContentDescription>
            </ContentWrap>
          )}
          {!isMobile && (
            <ContentWrap>
              <ContentTitle>Apelido da base instaldada</ContentTitle>
              <ContentDescription maxWidth="182px">
                {installedBaseNickname}
              </ContentDescription>
            </ContentWrap>
          )}
          <ContentWrap isMobile={isMobile}>
            <ContentTitle>Tipo da OS</ContentTitle>
            <ContentDescription>{osType}</ContentDescription>
          </ContentWrap>
        </>
      )}
      {!link && documentRequest?.downloadItem && (
        <ContainerStatusDownload isMobile={isMobile}>
          <BoxFileOs noMargin>
            <IconDownload />
          </BoxFileOs>
          <ContentStatusDownload>
            <div>
              <TextOS>
                Gerando OS
{' '}
<TextOsNumber>{osNumber}</TextOsNumber>
              </TextOS>
            </div>
            <PercentNumberAndStatusWrap>
              <NumberPercentWrap>
                <TextOsNumber>
                  {documentRequest?.percentDownload | 0}
%
</TextOsNumber>
              </NumberPercentWrap>
              <PercentDownloadWrap>
                <PercentStatusBar
                  percentDownload={documentRequest?.percentDownload | 0}
                />
              </PercentDownloadWrap>
            </PercentNumberAndStatusWrap>
          </ContentStatusDownload>
        </ContainerStatusDownload>
      )}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        dialogClassName="modal-90w"
        size="md"
        aria-labelledby="example-custom-modal-styling-title"
        animation={false}
        centered
      >
        <ModalContent
          setMailSuccess={setMailSuccess}
          mailSuccess={mailSuccess}
          sendMail={handleClickCreateOsAndSendMail}
          isLoading={isLoading}
          email={email}
          setEmail={setEmail}
          close={() => setShowModal(false)}
        />
      </Modal>
    </Container>
  );
}

export default FileItemOs;
